import _ from 'lodash'
import SendTo from 'scoreboard/components/send-to'
import SendToOptions from 'scoreboard/components/send-to-options'
import Tooltip from 'scoreboard/components/tooltip'

/**
 * Shared solution for sending a simple table to an excel file.
 * This is for small tables where excel is the only export option.
 * See usages for examples.
 *
 * @param {Element} target There to attach the tooltip
 *
 * @param {String} heading
 *
 * @param {Function} options.excelFn this is a function that must generate the excel file
 * and initiate the download
 *
 * @param {Function} options.csvDownloadFn this is a function that must generate the excel file
 * and initiate the download
 *
 * @param {Object} [options] Additional options that will be passed through to
 * SendToOptions.excel()
 *
 * @param {Object} [options.replaceDialog=true] Pass false to keep existing dialog(s) open
 * This is required to correctly capture HTML attributes from the table inside of dialogs
 */
function sendToExcelTooltip(target, heading, options = {}) {

	let sendToOptions
	const {csvDownloadFn, excelFn} = options
	if (excelFn) {
		sendToOptions = SendToOptions.excel(_.extend(options, {
			immediate: true
		}))
	} else if (csvDownloadFn) {
		sendToOptions = SendToOptions.csv(_.extend(options, {
			immediate: true
		}))
	}

	return new Tooltip({
		attachTo: target,
		content: new SendTo({
			heading,
			sendToOptions
		}),
		placement: 'below',
		arrow: 'right',
		extraClass: 'has-bootslide-menu'
	}).render()
}

export default sendToExcelTooltip
sendToExcelTooltip.__filename__ = 'components/export/send-to-excel-tooltip.js'
